import Axios from "axios";

const ApiRequest = {
  get(url) {
    return Axios.get(url)
      .then((response) => response.data)
      .catch((error) => {
        console.error("axios : " + error);
        throw error;
      });
  },

  post(url, params, config) {
    return Axios.post(url, params, config)
      .then((response) => response.data)
      .catch((error) => {
        console.error("axios : " + error);
        throw error;
      });
  },

  post(url, params) {
    return Axios.post(url, params)
      .then((response) => response.data)
      .catch((error) => {
        console.error("axios : " + error);
        throw error;
      });
  },

  put(url, params) {
    return Axios.put(url, params)
      .then((response) => response.data)
      .catch((error) => {
        console.error("axios : " + error);
        throw error;
      });
  },
};

export default ApiRequest;
